import React from 'react';
import PropTypes from 'prop-types';
import {utils, writeFile} from 'xlsx';
import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";
import {isEmpty, extractWorkSheetData, formatDate, ExcelDateToDateString} from "../../globals/GlobalFunctions";

export interface Props {
    excelData: any;
}

//maps for storing a subs address info
let addressMap = new Map<string, string>();

let address2Map = new Map<string, string>();

let cityMap = new Map<string, string>();

let stateMap = new Map<string, string>();

let zipMap = new Map<string, string>();

//pipe delimited
function AMPSFormatter ({excelData}: Props) {
    const [successAlert, setSuccessAlert] = React.useState(false);
    const [errorAlert, setErrorAlert] = React.useState(false);
    try{
        //Check for 2 sheets here
        if (!isEmpty(excelData) && excelData.Sheets.AMPS !== undefined) {
            let sheetDataArray = extractWorkSheetData(excelData.Sheets.AMPS);

            let rawCellArray: any[] = sheetDataArray[0];

            let columnRange: number = sheetDataArray[1];

            let rowRange: number = sheetDataArray[2];

            const valuesIndexCollection = {
                memberSegIndex: rawCellArray.indexOf('Member Sequence') + 1,
                subscriberSSNIndex: rawCellArray.indexOf('Subscriber SSN') + 1,
                altIDIndex: rawCellArray.indexOf('Member Alternate ID') + 1,
                fnIndex: rawCellArray.indexOf('Member First Name') + 1,
                //mnIndex: rawCellArray.indexOf('Member Middle Name') + 1,
                lnIndex: rawCellArray.indexOf('Member Last Name') + 1,
                planIndex: rawCellArray.indexOf('Plan ID') + 1,
                //divisionIndex: rawCellArray.indexOf('Division ID') + 1,
                dobIndex: rawCellArray.indexOf('Member Date of Birth') + 1,
                subscriberIndex: rawCellArray.indexOf('Subscriber ID') + 1,
                phoneIndex: rawCellArray.indexOf('Member Home Phone') + 1,
                enrollDateIndex: rawCellArray.indexOf('Effective Date') + 1,
                disenrollDateIndex: rawCellArray.indexOf('Termination Date') + 1,
                groupIndex: rawCellArray.indexOf('Group ID') + 1,
                addIndex: rawCellArray.indexOf('Member Address') + 1,
                add2Index: rawCellArray.indexOf('Member Address 2') + 1,
                cityIndex: rawCellArray.indexOf('Member City') + 1,
                stateIndex: rawCellArray.indexOf('Member State') + 1,
                zipIndex: rawCellArray.indexOf('Member Zip Code') + 1,
                emailIndex: rawCellArray.indexOf('Member Email Address') + 1,
                sexIndex: rawCellArray.indexOf('Member Gender') + 1,
                planTypeIndex: rawCellArray.indexOf('Plan Type') + 1,
            }

            //we loop to save the addresses for subs since dependents dont always have subs
            for (let i = 1; i < rowRange; i++) {
                let rowMultiplier = columnRange * i - 1;

                if(valuesIndexCollection.subscriberSSNIndex > 0 && rawCellArray[(rowMultiplier + valuesIndexCollection.memberSegIndex)].toString() === "01"){
                    if(valuesIndexCollection.addIndex > 0) {
                        addressMap.set(rawCellArray[(rowMultiplier + valuesIndexCollection.subscriberSSNIndex)].toString(), rawCellArray[(rowMultiplier + valuesIndexCollection.addIndex)].toString())
                    }
                    if(valuesIndexCollection.add2Index > 0) {
                        address2Map.set(rawCellArray[(rowMultiplier + valuesIndexCollection.subscriberSSNIndex)].toString(), rawCellArray[(rowMultiplier + valuesIndexCollection.add2Index)].toString())
                    }
                    if(valuesIndexCollection.cityIndex > 0) {
                        cityMap.set(rawCellArray[(rowMultiplier + valuesIndexCollection.subscriberSSNIndex)].toString(), rawCellArray[(rowMultiplier + valuesIndexCollection.cityIndex)].toString())
                    }
                    if(valuesIndexCollection.stateIndex > 0) {
                        stateMap.set(rawCellArray[(rowMultiplier + valuesIndexCollection.subscriberSSNIndex)].toString(), rawCellArray[(rowMultiplier + valuesIndexCollection.stateIndex)].toString())
                    }
                    if(valuesIndexCollection.zipIndex > 0) {
                        zipMap.set(rawCellArray[(rowMultiplier + valuesIndexCollection.subscriberSSNIndex)].toString(), rawCellArray[(rowMultiplier + valuesIndexCollection.zipIndex)].toString())
                    }
                }
            }

            //headers in first array
            let arrayOfMemberArrays: any[] = [[
                "Member ID|Member Type|Primary Member ID|First Name|Last Name|Address Line 1|" +
                "Address Line 2|City|State|Zip Code|Phone Number|Fax Number|Email address|Gender|Effective Date|Termination Date|" +
                "Birthdate|Client Code|Group Number|Sub-Group Number|Plan Code"
            ]];

            //loop through all member rows
            for (let i = 1; i < rowRange; i++) {
                //our member to later be pushed. Oh from what humble origins it begins
                let memberArray: any[] = [];
                let memberString: string = "";
                //for each new member array we skip over the previous members determined by the column length, removing 1 to account for our zero based index at the beginning
                let rowMultiplier = columnRange * i - 1;

                let today = new Date();

                let termDate = new Date(Math.round((rawCellArray[(rowMultiplier + valuesIndexCollection.disenrollDateIndex)] - 25568)*86400*1000));

                //exclude termed records and non MRX plans
                if (termDate > today && valuesIndexCollection.planTypeIndex > 0 &&
                    rawCellArray[(rowMultiplier + valuesIndexCollection.planTypeIndex)].toString() === "Medical and RX Plan (MRX)") {

                    //they want member seg so it can be matched to the subscriber. If no alt, then sub ID
                    if (valuesIndexCollection.altIDIndex > 0 && valuesIndexCollection.memberSegIndex > 0) {
                        if (rawCellArray[(rowMultiplier + valuesIndexCollection.altIDIndex)].toString().length > 0) {
                            memberString += (rawCellArray[(rowMultiplier + valuesIndexCollection.altIDIndex)].toString() +
                                rawCellArray[(rowMultiplier + valuesIndexCollection.memberSegIndex)].toString() + "|");
                        } else if (valuesIndexCollection.subscriberIndex > 0 && rawCellArray[(rowMultiplier + valuesIndexCollection.subscriberIndex)].toString().length > 0) {
                            memberString += (rawCellArray[(rowMultiplier + valuesIndexCollection.subscriberIndex)].toString() +
                                rawCellArray[(rowMultiplier + valuesIndexCollection.memberSegIndex)].toString() + "|");
                        } else {
                            memberString += "|";
                        }
                    } else {
                        memberString += "|";
                    }

                    //Primary or dependant
                    if (valuesIndexCollection.memberSegIndex > 0) {
                        if(rawCellArray[(rowMultiplier + valuesIndexCollection.memberSegIndex)].toString() === "01"){
                            memberString += "P|";
                        }
                        else {
                            memberString += "D|";
                        }

                    } else {
                        memberString += "|";
                    }

                    //same as above but just for the subscriber so always 01
                    if (valuesIndexCollection.altIDIndex > 0) {
                        if (rawCellArray[(rowMultiplier + valuesIndexCollection.altIDIndex)].toString().length > 0) {
                            memberString += (rawCellArray[(rowMultiplier + valuesIndexCollection.altIDIndex)].toString()  + "01|");
                        } else if (valuesIndexCollection.subscriberIndex > 0 && rawCellArray[(rowMultiplier + valuesIndexCollection.subscriberIndex)].toString().length > 0) {
                            memberString += (rawCellArray[(rowMultiplier + valuesIndexCollection.subscriberIndex)].toString() + "01|");
                        } else {
                            memberString += "|";
                        }
                    } else {
                        memberString += "|";
                    }

                    //first name
                    if (valuesIndexCollection.fnIndex > 0) {
                        memberString += (rawCellArray[(rowMultiplier + valuesIndexCollection.fnIndex)].toString().toUpperCase() + "|");
                    } else {
                        memberString += "|";
                    }

                    //last name
                    if (valuesIndexCollection.lnIndex > 0) {
                        memberString += (rawCellArray[(rowMultiplier + valuesIndexCollection.lnIndex)].toString().toUpperCase() + "|");
                    } else {
                        memberString += "|";
                    }

                    //if dep grab address from map for each of the following five fields
                    if (valuesIndexCollection.addIndex > 0 && valuesIndexCollection.memberSegIndex > 0 && rawCellArray[(rowMultiplier + valuesIndexCollection.memberSegIndex)].toString() === "01") {
                        memberString += (rawCellArray[(rowMultiplier + valuesIndexCollection.addIndex)].toString().toUpperCase() + "|");
                    }
                    else if(valuesIndexCollection.subscriberSSNIndex > 0 && addressMap.has(rawCellArray[(rowMultiplier + valuesIndexCollection.subscriberSSNIndex)].toString())){
                        memberString += addressMap.get(rawCellArray[(rowMultiplier + valuesIndexCollection.subscriberSSNIndex)].toString()) + "|";
                    }
                    else {
                        memberString += "|";
                    }

                    if (valuesIndexCollection.add2Index > 0 && valuesIndexCollection.memberSegIndex > 0 && rawCellArray[(rowMultiplier + valuesIndexCollection.memberSegIndex)].toString() === "01") {
                        memberString += (rawCellArray[(rowMultiplier + valuesIndexCollection.add2Index)].toString().toUpperCase() + "|");
                    }
                    else if(valuesIndexCollection.subscriberSSNIndex > 0 && address2Map.has(rawCellArray[(rowMultiplier + valuesIndexCollection.subscriberSSNIndex)].toString())){
                        memberString += address2Map.get(rawCellArray[(rowMultiplier + valuesIndexCollection.subscriberSSNIndex)].toString()) + "|";
                    }
                    else {
                        memberString += "|";
                    }

                    if (valuesIndexCollection.cityIndex > 0 && valuesIndexCollection.memberSegIndex > 0 && rawCellArray[(rowMultiplier + valuesIndexCollection.memberSegIndex)].toString() === "01") {
                        memberString += (rawCellArray[(rowMultiplier + valuesIndexCollection.cityIndex)].toString().toUpperCase() + "|");
                    }
                    else if(valuesIndexCollection.subscriberSSNIndex > 0 && cityMap.has(rawCellArray[(rowMultiplier + valuesIndexCollection.subscriberSSNIndex)].toString())){
                        memberString += cityMap.get(rawCellArray[(rowMultiplier + valuesIndexCollection.subscriberSSNIndex)].toString()) + "|";
                    }
                    else {
                        memberString += "|";
                    }

                    if (valuesIndexCollection.stateIndex > 0 && valuesIndexCollection.memberSegIndex > 0 && rawCellArray[(rowMultiplier + valuesIndexCollection.memberSegIndex)].toString() === "01") {
                        memberString += (rawCellArray[(rowMultiplier + valuesIndexCollection.stateIndex)].toString().toUpperCase() + "|");
                    }
                    else if(valuesIndexCollection.subscriberSSNIndex > 0 && stateMap.has(rawCellArray[(rowMultiplier + valuesIndexCollection.subscriberSSNIndex)].toString())){
                        memberString += stateMap.get(rawCellArray[(rowMultiplier + valuesIndexCollection.subscriberSSNIndex)].toString()) + "|";
                    }
                    else {
                        memberString += "|";
                    }

                    if (valuesIndexCollection.zipIndex > 0 && valuesIndexCollection.memberSegIndex > 0 && rawCellArray[(rowMultiplier + valuesIndexCollection.memberSegIndex)].toString() === "01") {
                        memberString += (rawCellArray[(rowMultiplier + valuesIndexCollection.zipIndex)].toString().toUpperCase() + "|");
                    }
                    else if(valuesIndexCollection.subscriberSSNIndex > 0 && zipMap.has(rawCellArray[(rowMultiplier + valuesIndexCollection.subscriberSSNIndex)].toString())){
                        memberString += zipMap.get(rawCellArray[(rowMultiplier + valuesIndexCollection.subscriberSSNIndex)].toString()) + "|";
                    }
                    else {
                        memberString += "|";
                    }

                    if (valuesIndexCollection.phoneIndex > 0) {
                        memberString += (rawCellArray[(rowMultiplier + valuesIndexCollection.phoneIndex)].toString() + "|");
                    } else {
                        memberString += "|";
                    }

                    memberString += "|";

                    if (valuesIndexCollection.emailIndex > 0) {
                        memberString += (rawCellArray[(rowMultiplier + valuesIndexCollection.emailIndex)].toString().toUpperCase() + "|");
                    } else {
                        memberString += "|";
                    }

                    if (valuesIndexCollection.sexIndex > 0) {
                        let sex = rawCellArray[(rowMultiplier + valuesIndexCollection.sexIndex)].toUpperCase();
                        if(sex === "MALE"){
                            sex = "M";
                        }
                        else if(sex === "FEMALE"){
                            sex = "F";
                        }
                        else if(sex === "UNDEFINED"){
                            sex = "U";
                        }
                        memberString += sex + "|";
                    }
                    else {
                        memberString += "|";
                    }

                    //uses standard date conversion
                    if (valuesIndexCollection.enrollDateIndex > 0) {
                        let date = rawCellArray[(rowMultiplier + valuesIndexCollection.enrollDateIndex)].toString();
                        if (date.includes("/")) {
                            date = formatDate(date);
                        } else if (date.length > 0 && date.length < 6) {
                            date = ExcelDateToDateString(date);
                        }
                        if (date.length > 7) {
                            date = date.substring(4, 6) + "/" + date.substring(6, 8) + "/" + date.substring(0, 4);
                        }
                        memberString += (date + "|");
                    } else {
                        memberString += "|";
                    }

                    //filters out the 12/31/2222 dates
                    if (valuesIndexCollection.disenrollDateIndex > 0) {
                        let date = rawCellArray[(rowMultiplier + valuesIndexCollection.disenrollDateIndex)].toString();
                        if (date.includes("/")) {
                            date = formatDate(date);
                        } else if (date.length > 0 && date.length < 6) {
                            date = ExcelDateToDateString(date);
                        }
                        if (date.length > 7) {
                            date = date.substring(4, 6) + "/" + date.substring(6, 8) + "/" + date.substring(0, 4);
                        }else if (date === "117974") {
                            date = "";
                        }
                        memberString += (date + "|");
                    } else {
                        memberString += "|";
                    }

                    if (valuesIndexCollection.dobIndex > 0) {
                        let date = rawCellArray[(rowMultiplier + valuesIndexCollection.dobIndex)].toString();
                        if (date.includes("/")) {
                            date = formatDate(date);
                        } else if (date.length > 0 && date.length < 6) {
                            date = ExcelDateToDateString(date);
                        }
                        if (date.length > 7) {
                            date = date.substring(4, 6) + "/" + date.substring(6, 8) + "/" + date.substring(0, 4);
                        }
                        memberString += (date + "|");
                    } else {
                        memberString += "|";
                    }

                    memberString += "|";

                    if (valuesIndexCollection.groupIndex > 0) {
                        memberString += (rawCellArray[(rowMultiplier + valuesIndexCollection.groupIndex)].toString() + "|");
                    } else {
                        memberString += "|";
                    }

                    memberString += "|";

                    if (valuesIndexCollection.planIndex > 0) {
                        memberString += (rawCellArray[(rowMultiplier + valuesIndexCollection.planIndex)].toString() + "|");
                    } else {
                        memberString += "|";
                    }

                    memberArray.push(memberString);

                    arrayOfMemberArrays.push(memberArray);
                }
            }

            //create our workbook
            const eligWorkbook = utils.book_new();
            //make the member sheet from our member array of arrays
            let ws1 = utils.aoa_to_sheet(arrayOfMemberArrays, {dateNF: 'mm.dd.yyyy'});

            //dates for yyyymmddhhmmss format
            const today = new Date();

            const month = today.getMonth() + 1;

            let monthString = "";

            let dayString = "";

            let hourString = "";

            let minuteString = "";

            let secondString = "";

            if(month < 10){
                monthString = "0" + month.toString();
            }
            else{
                monthString = month.toString();
            }

            const day = today.getDate();

            if(day < 10) {
                dayString = "0" + day.toString();
            }
            else {
                dayString = day.toString();
            }

            const year = today.getFullYear();

            const hours = today.getHours();

            if(hours < 10) {
                hourString = "0" + hours.toString();
            }
            else {
                hourString = hours.toString();
            }

            const minutes = today.getMinutes();

            if(minutes < 10) {
                minuteString = "0" + minutes.toString();
            }
            else {
                minuteString = minutes.toString();
            }

            const seconds = today.getSeconds();

            if(seconds < 10) {
                secondString = "0" + seconds.toString();
            }
            else {
                secondString = seconds.toString();
            }

            //add it to the new workbook
            utils.book_append_sheet(eligWorkbook, ws1, "CAS_ELIGIBILITY_" + year + monthString + dayString + hourString + minuteString + secondString);
            //it exists and has a sheet send it back to app for export
            if (eligWorkbook && eligWorkbook.SheetNames.includes("CAS_ELIGIBILITY_" + year + monthString + dayString + hourString + minuteString + secondString)) {
                if (!eligWorkbook.Props) eligWorkbook.Props = {};

                //setting the workbook title through props
                eligWorkbook.Props.Title = "CAS_ELIGIBILITY_" + year + monthString + dayString + hourString + minuteString + secondString + ".txt";

                //writing the file which will make the download, second param is the name of the file and third is required options
                writeFile(eligWorkbook, "CAS_ELIGIBILITY_" + year + monthString + dayString + hourString + minuteString + secondString + ".txt", {});

                console.log("File Export Complete!");
                setSuccessAlert(true);
            } else {
                setErrorAlert(true);
                console.log("Unknown Export Error!");
            }

            //clear it out at the end in case of rerendering
            excelData.Sheets.AMPS = undefined;
        }
    }
    catch(e) {
        console.log("ERROR", e);

        setErrorAlert(true);
        //clear it out after errors in case of rerendering otherwise the error spams will continue until morale improves
        excelData.Sheets.AMPS = undefined;

    }
    return (
        <div>
            {successAlert ? <Alert severity='success' onClose={() => setSuccessAlert(false)} variant="filled">
                <AlertTitle>Success!</AlertTitle>
                File Download Complete!
            </Alert> : <></> }
            {errorAlert ? <Alert severity='error' onClose={() => setErrorAlert(false)} variant="filled">
                <AlertTitle>Error!</AlertTitle>
                There was an error with this file!
            </Alert> : <></> }
        </div>
    );
}


export default React.memo(AMPSFormatter)

AMPSFormatter.propTypes = {
    excelData: PropTypes.object.isRequired,
};